import Utils from '@/ecm/common/Utils';
export default class ContentTypeAutoImportConfigField {
    constructor(dto) {
        this.uuid = Utils.object.getUUID();
        this.defFieldCode = '';
        this.value = '';
        this.usesKeyword = '';

        if (dto) {
            this.value = dto.value;
            this.defFieldCode = dto.defFieldCode;
            this.usesKeyword = dto.usesKeyword;
        }
    }

    toDto() {
        return {
            Value: this.value,
            DefFieldCode: this.defFieldCode,
            UsesKeyword: this.usesKeyword,
        };
    }
}
